module.exports = __webpack_public_path__ + "static/media/cutlery.a0add291.svg";